import { useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { steamStatus } from '../interfaces';
import { getSteamStatus } from '../selector';

export const useSteamStatus = () => ({
  status: useSelector<IStore, steamStatus>(getSteamStatus),
});
